import { render, staticRenderFns } from "./ClpTransactionHistoryReport.vue?vue&type=template&id=f8ce1042"
import script from "./ClpTransactionHistoryReport.vue?vue&type=script&lang=js"
export * from "./ClpTransactionHistoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports